import { render } from "./BarChart.vue?vue&type=template&id=5b2c5fa5&ts=true"
import script from "./BarChart.vue?vue&type=script&lang=ts"
export * from "./BarChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Charts/BarChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b2c5fa5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b2c5fa5', __exports__)) {
    api.reload('5b2c5fa5', __exports__)
  }
  
  module.hot.accept("./BarChart.vue?vue&type=template&id=5b2c5fa5&ts=true", () => {
    api.rerender('5b2c5fa5', render)
  })

}


export default __exports__